// Module
var code = "<div id=\"V-B2D9F2FF-11D2-42E2-B018-C3C207701A2E\" data-b-event-click=\"{Binding select}\" data-b-class-selected=\"{Binding isselected}\" data-b-content=\"{Binding element,ViewSelector:tabViewSelector}\"> </div> ";
// Exports
export default code;